import "core-js/modules/es.array.splice";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import ProxyListTable from '@/components/ProxyListTable.vue';
import ProxyInfoFormDialog from './ProxyInfoFormDialog.vue';

var ProxyInfo = /*#__PURE__*/function (_Vue) {
  _inherits(ProxyInfo, _Vue);

  var _super = _createSuper(ProxyInfo);

  function ProxyInfo() {
    var _this;

    _classCallCheck(this, ProxyInfo);

    _this = _super.apply(this, arguments);
    _this.dialogFormVisible = false;
    _this.tempProxy = null;
    _this.tempProxyIndex = 0;
    return _this;
  }

  _createClass(ProxyInfo, [{
    key: "handleDialogSubmit",
    value: function handleDialogSubmit(e) {
      if (this.tempProxy === null) {
        // 新建
        this.proxyList.push(e);
      } else {
        // 编辑
        this.$set(this.proxyList, this.tempProxyIndex, e);
      }
    }
  }, {
    key: "handleEdit",
    value: function handleEdit(item) {
      var index = item.$index,
          data = item.row; // this.tempProxy = Object.assign({}, data)

      this.tempProxy = data;
      this.tempProxyIndex = index;
      this.dialogFormVisible = true;
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(item) {
      var index = item.$index;
      this.proxyList.splice(index, 1);
    }
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.tempProxy = null;
      this.dialogFormVisible = true;
    }
  }]);

  return ProxyInfo;
}(Vue);

__decorate([Prop({
  required: true,
  type: Array
})], ProxyInfo.prototype, "litigationStatusIdOptions", void 0);

__decorate([Prop({
  required: true
})], ProxyInfo.prototype, "clientList", void 0);

__decorate([Prop({
  required: true
})], ProxyInfo.prototype, "proxyList", void 0);

ProxyInfo = __decorate([Component({
  components: {
    ProxyInfoFormDialog: ProxyInfoFormDialog,
    ProxyListTable: ProxyListTable
  }
})], ProxyInfo);
export default ProxyInfo;